import {mapGetters} from 'vuex';

export default {
    name: 'schoolsCardSection',
    props: {
        data: {
            type: Array,
            default: []
        },
        title: {
            type: String,
            default: ''
        },
        showLinks: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('glb', ['glb'])
        }
}
